import common from './common/ordriket'

export default {
  "name": "Ordriket 2",
  "slug": "ordriket-2",
  "level": 2,
  "assets": {
    "logo": "/themes/ordriket/ordriket-2.svg",
    "favicon": "/themes/ordriket/ordriket-fav.png"
  },
  "login": {
    "type": "guardTeacherOnly"
  },
  "langs": [
    {
      "code": "nb",
      "slug": "ordriket-2",
      "label": "Bokmål"
    },
    {
      "code": "nn",
      "slug": "ordriket-2-nn",
      "label": "Nynorsk"
    }
  ],
  ...common,
  "dbok": {
    "nb": [
      {
        "bookId": "5ec77ddded80140019d9d733",
      },
      {
        "bookId": "5ea8418bbf27dd001a619b4d",
      },
      {
        "bookId": "5fd337dc44049f001976ded3",
      },
      {
        "bookId": "5fb50293be08de001240b08e",
      },
      {
        "bookId": "5fe1b04e44049f001978afe4",
      }
    ],
    "nn": [
      {
        "bookId": "5f1853887228e00012e61136",
      },
      {
        "bookId": "5eb91d53ff429d00198b34b0",
      },
      {
        "bookId": "5fd3502844049f001976eee0",
      },
      {
        "bookId": "5ffd738b6468f3001a1e44b7",
      },
      {
        "bookId": "5fe1b04e44049f001978afe4",
      }
    ]
  },
}
